import { axInstBasic } from "../../components/Service/Service";

export const fetchcustdetail = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getCustData`,
            payload
        );
        return res.data.result;
    } catch (error) {
        console.error(error);
        throw error;
    }
};